import React from 'react';
import { cn } from '../../utils/cn';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> = ({ children, className, ...props }) => {
  return (
    <div
      className={cn('bg-card rounded-lg shadow-sm border border-border', className)}
      {...props}
    >
      {children}
    </div>
  );
};

Card.displayName = 'Card';
